import { useContext } from 'react';
import LocaleContext from '../LocaleContext';

export const useLocale = () => {
  const locale = useContext(LocaleContext);
  return locale;
};
